module.exports = __webpack_public_path__ + "static/media/camera-icon.ef38276c.svg";